import React from 'react';

import { NavLink } from 'react-router-dom';

import { Box, ListItem, ListItemButton } from '@mui/material';

import { COLORS } from '../../../Constant/COLORS';

const NavLinkLayout = ({ children, to, icon: Icon, sx, ...props }) => (
  <ListItem disableGutters disablePadding sx={{ mb: 0.5, ...sx }} {...props}>
    <NavLink
      style={{ textDecoration: 'none', width: '100%' }}
      to={`../${to}`}
      children={({ isActive }) => (
        <ListItemButton
          selected={isActive}
          sx={{
            position: 'relative',
            borderRadius: 2,
            gap: 1.25,
            fontWeight: 600,
            color: isActive ? COLORS.teal : COLORS.inkSoft,
            transition: 'color .18s ease, background-color .18s ease, padding-left .18s ease',
            '&.Mui-selected, &.Mui-selected:hover': {
              backgroundColor: COLORS.tealSoft,
              color: COLORS.teal,
            },
            '&:hover': { backgroundColor: COLORS.surfaceAlt, pl: 2.25 },
          }}
        >
          {/* animated left active bar */}
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              width: 3,
              height: isActive ? 20 : 0,
              borderRadius: 3,
              bgcolor: COLORS.teal,
              transition: 'height .25s cubic-bezier(0.22,1,0.36,1)',
            }}
          />
          {Icon && <Icon size={18} strokeWidth={1.8} />}
          {children}
        </ListItemButton>
      )}
    />
  </ListItem>
);

export default NavLinkLayout;
